import { ORDER_SERVICE_MAINTENANCE_ALERT, BANNER_MESSAGE_ALERT, TRACKING_SERVICE_MAINTENANCE_ALERT } from 'actions';


export default function (state = { maintenanceMessage: {}, bannerMessage: {}, disabled: false }, action) {
    switch (action.type) {
        case ORDER_SERVICE_MAINTENANCE_ALERT: {
            if (action &&
                action.payload &&
                action.payload.data) {
                const alertMsg = action.payload.data.serviceResponse || action.payload.data;
                const maintenanceMessage = {
                    alertType: 'Maintenance',
                    message: alertMsg['message']
                };
                const bannerMessage = {
                    alertType: 'Maintenance',
                    message: alertMsg['bannerMessage']
                };
                const disabled = alertMsg['maintenanceEnabled'] === true || alertMsg['maintenanceEnabled'] === 'true';
                return { maintenanceMessage, bannerMessage, disabled };
            } else {
                return state;
            }
        }

        case BANNER_MESSAGE_ALERT: {
            const bannerAlertData = action?.payload?.data?.serviceResponse || action?.payload?.data;
            let bannerAlertBannerMessage = bannerAlertData?.['bannerMessage'] ?? undefined;
            let maintenanceOrderAlertBannerMessageObject = {
                alertType: 'Maintenance',
                message: bannerAlertBannerMessage
            };
            return { ...state, bannerMessage: maintenanceOrderAlertBannerMessageObject };
        }
        case TRACKING_SERVICE_MAINTENANCE_ALERT: {
            if (action &&
                action.payload &&
                action.payload.data) {
                const alertMsg = action.payload.data.serviceResponse || action.payload.data;
                const maintenanceMessage = {
                    alertType: 'Maintenance',
                    message: alertMsg['message']
                };
                const bannerMessage = {
                    alertType: 'Maintenance',
                    message: alertMsg['bannerMessage']
                };
                const trackingdisabled = alertMsg['maintenanceEnabled'] === true || alertMsg['maintenanceEnabled'] === 'true';
                return { maintenanceMessage, bannerMessage, trackingdisabled };
            } else {
                return state;
            }
        }
        default:
            return state;
    }
}
